/* eslint no-bitwise: "off" */
/* eslint no-plusplus: "off" */

export default {
  hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    return (hash % 360) / 360;
  },
  intToRGB(i) {
    const c = (i & 0x00FFFFFF)
      .toString(16)
      .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
  },

  getRandomPastelColor(seed = null) {
    const colorSeed = seed || Math.random();
    const hue = Math.floor(colorSeed * 360);
    const randomColor = `hsl(${hue}, 70%, 80%)`;
    return randomColor;
  },
};
